import { Text } from 'blaze-ui/Text/Text'
import Styles from './BrainstormIdeasBanner.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Button } from 'blaze-ui/Button'
import { ContentType } from 'components/ContentType/ContentType'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { WizardButtonProps } from '../WizardButton/Types'

export const BrainstormIdeasBanner = ({
  initialValues,
  onSuccess,
  schemaModifier,
  initialFormStatus,
}: Omit<WizardButtonProps, 'channelKey'>) => {
  return (
    <div className={Styles.brainstormIdeasContainer}>
      <div className={Styles.left}>
        <Heading level={2}>Brainstorm Content Ideas</Heading>
        <Text>Blaze gives you the ideas you need to start marketing your business.</Text>
        <div>
          <ContentType
            type={GenerationType.ContentPlan}
            schemaModifier={schemaModifier}
            initialFormStatus={initialFormStatus}
            initialValues={initialValues}
            onSuccess={onSuccess}
          >
            <Button size="lg">Generate Content Ideas</Button>
          </ContentType>
        </div>
      </div>
      <div className={Styles.image}>
        <img
          src="https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Ideas_ubduj4.png"
          alt=""
        />
      </div>
    </div>
  )
}
